import {ReportType} from '../../entities/reports/constants';
import type {
  ReportsResponseType,
  ReportsReturnValueType,
} from '../../repositories/reportsRepository';

export function getReportsFromPages(
  data: ReportsReturnValueType | undefined,
): ReportsResponseType | undefined {
  if (!data?.ok) return undefined;
  const reports = data.value.reports
    .filter(
      (report): report is Exclude<typeof report, undefined> => report !== null,
    )
    .map((report) => {
      if (report.isEntrySheet) {
        return {
          ...report,
          type: ReportType.ES,
        };
      }

      return report;
    });

  return {
    ...data.value,
    reports,
  };
}
